<div class="hidden-xs first-container">
  <app-map-plan-building-floor-base
    [buildingFloor]="buildingFloor"
  >
  </app-map-plan-building-floor-base>
  <app-touch-guide></app-touch-guide>
</div>



// WEBPACK FOOTER //
// ./src/app/floors/floors.component.html